import { Theme } from "@mui/material";
import { createStyles, makeStyles } from "@mui/styles";

export const Styles = makeStyles((theme: Theme) =>
  createStyles({
    drawerRoot: {
      width: "100%",
      height: "100%",
      backgroundColor: theme.palette.background.paper,
      display: "flex",
      flexDirection: "column",
      paddingTop: 0,
      direction: "rtl",
      overflow: "hidden",
    },

    logoImage: {
      height: 56,
      minHeight: 56,
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      padding: "0 24px",
      boxSizing: "border-box",
      borderBottom: `1px solid ${theme.palette.divider}`,
    },

    logoText: {
      fontSize: 14,
      fontWeight: 700,
      color: theme.palette.secondary.main,
      fontFamily: theme.typography.fontFamily,
    },

    drawerList: {
      flex: 1,
      minHeight: 0,
      overflowY: "auto",
      padding: "14px 12px !important",
      scrollbarWidth: "none",
      msOverflowStyle: "none",
      "&::-webkit-scrollbar": {
        display: "none",
      },
    },

    drawerLink: {
      textDecoration: "none",
      color: "inherit",
      display: "block",
    },

    drawerItem: {
      minHeight: "42px !important",
      borderRadius: "4px !important",
      padding: "0 14px !important",
      marginBottom: "6px !important",
      color: `${theme.palette.text.primary} !important`,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "row",

      "&:hover": {
        backgroundColor: `${theme.palette.background.tableRowHover} !important`,
      },
    },

    drawerListItems: {
      backgroundColor: `${theme.palette.info.light} !important`,
    },

    drawerIcon: {
      minWidth: "24px !important",
      width: "24px !important",
      marginLeft: "10px !important",
      marginRight: "0px !important",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },

    drawerText: {
      fontFamily: `${theme.typography.fontFamily} !important`,
      fontWeight: "400 !important",
      fontSize: "14px !important",
      lineHeight: "140% !important",
      letterSpacing: "0%",
      color: theme.palette.text.primary,
      textAlign: "right",
    },

    drawerListItemText: {
      fontFamily: `${theme.typography.fontFamily} !important`,
      color: `${theme.palette.primary.main} !important`,
      fontWeight: "400 !important",
    },

    languageWrapper: {
      marginTop: "auto",
      flexShrink: 0,
      padding: "16px",
      display: "flex",
      gap: "8px",
      justifyContent: "center",
      borderTop: `1px solid ${theme.palette.divider}`,
    },

    languageButton: {
      border: `1px solid ${theme.palette.divider}`,
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.secondary,
      borderRadius: "6px",
      padding: "6px 12px",
      cursor: "pointer",
      fontSize: "13px",
      fontFamily: theme.typography.fontFamily,
    },

    activeLanguageButton: {
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.info.light,
      color: theme.palette.primary.main,
      borderRadius: "6px",
      padding: "6px 12px",
      cursor: "pointer",
      fontSize: "13px",
      fontWeight: 600,
      fontFamily: theme.typography.fontFamily,
    },

    backButton: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      gap: "8px",
      padding: "14px 24px",
      cursor: "pointer",
      backgroundColor: "transparent",
      border: "none",
      width: "100%",
      boxSizing: "border-box",
      flexShrink: 0,
      fontFamily: theme.typography.fontFamily,
      fontSize: "14px",
      fontWeight: 400,
      color: theme.palette.text.primary,
      textAlign: "right",

      "&:hover": {
        backgroundColor: theme.palette.background.tableRowHover,
      },
    },

    logoImageWithoutBorder: {
      borderBottom: "none",
    },

    backButtonIcon: {
      fontSize: "16px !important",
      color: theme.palette.text.primary,
    },

    nestedItemContent: {
      display: "flex",
      alignItems: "center",
      width: "100%",
      flexDirection: "row",
    },

    nestedItemChevron: {
      display: "flex",
      alignItems: "center",
      color: theme.palette.text.primary,
      transition: "transform 0.2s ease",
      flexShrink: 0,
    },

    nestedItemChevronExpanded: {
      transform: "rotate(180deg)",
    },

    subDrawerDivider: {
      margin: "6px 14px !important",
      borderColor: theme.palette.divider,
    },
  })
);
